/* Nineteenth Society persona Story card (1080 x 1920), drawn in the browser. */
(function (root) {
  var C = {
    green: '#2E4B3F', soft: '#8CA08C', cream: '#F3EBDC', white: '#F8F6F1',
    taupe: '#DDD6CC', burgundy: '#4A2C31', matcha: '#D2E87A'
  };
  var SERIF = '"NS Card Serif", "Cormorant Garamond", Georgia, serif';
  var SANS = '"NS Card Sans", "Jost", Helvetica, Arial, sans-serif';

  function loadImg(src) {
    return new Promise(function (res) {
      if (!src) return res(null);
      var i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = function () { res(i); };
      i.onerror = function () { res(null); };
      i.src = src;
    });
  }

  function spaced(ctx, text, x, y, spacing, align) {
    var chars = text.split('');
    var w = 0;
    chars.forEach(function (ch, i) { w += ctx.measureText(ch).width + (i < chars.length - 1 ? spacing : 0); });
    var sx = align === 'center' ? x - w / 2 : align === 'right' ? x - w : x;
    var oldAlign = ctx.textAlign;
    ctx.textAlign = 'left';
    chars.forEach(function (ch) { ctx.fillText(ch, sx, y); sx += ctx.measureText(ch).width + spacing; });
    ctx.textAlign = oldAlign;
    return w;
  }

  function fitSize(ctx, text, font, start, maxW, min) {
    var s = start;
    while (s > min) {
      ctx.font = font.replace('%s', s);
      if (ctx.measureText(text).width <= maxW) break;
      s -= 2;
    }
    return s;
  }

  function rule(ctx, x1, y, x2, w, color) {
    ctx.strokeStyle = color; ctx.lineWidth = w;
    ctx.beginPath(); ctx.moveTo(x1, y); ctx.lineTo(x2, y); ctx.stroke();
  }

  /* A loose felt-tip scribble, seeded so each persona's mark is the same every time. */
  function scribble(ctx, x, y, w, seed, color, lw) {
    var r = seed;
    function rnd() { r = (r * 9301 + 49297) % 233280; return r / 233280; }
    ctx.save();
    ctx.strokeStyle = color; ctx.lineWidth = lw; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    ctx.globalAlpha = 0.92;
    ctx.beginPath();
    ctx.moveTo(x, y + 4);
    var passes = [[0, 1, 0], [1, 0.06, 12], [0.06, 0.94, 22]];
    passes.forEach(function (p) {
      var steps = 6;
      for (var i = 1; i <= steps; i++) {
        var t = p[0] + (p[1] - p[0]) * (i / steps);
        ctx.quadraticCurveTo(x + w * (t - 0.04), y + p[2] + (rnd() - 0.5) * 10, x + w * t, y + p[2] + (rnd() - 0.5) * 6);
      }
    });
    ctx.stroke();
    ctx.restore();
  }

  function sticker(ctx, cx, cy, angle, lines) {
    ctx.save();
    ctx.translate(cx, cy); ctx.rotate(angle);
    var w = 330, h = 136;
    ctx.shadowColor = 'rgba(0,0,0,0.28)'; ctx.shadowBlur = 18; ctx.shadowOffsetY = 8;
    ctx.fillStyle = C.burgundy; ctx.fillRect(-w / 2, -h / 2, w, h);
    ctx.shadowColor = 'transparent';
    ctx.strokeStyle = C.cream; ctx.lineWidth = 2;
    ctx.strokeRect(-w / 2 + 12, -h / 2 + 12, w - 24, h - 24);
    ctx.lineWidth = 1;
    ctx.strokeRect(-w / 2 + 19, -h / 2 + 19, w - 38, h - 38);
    ctx.fillStyle = C.cream; ctx.textBaseline = 'middle';
    ctx.font = '500 25px ' + SANS;
    spaced(ctx, lines[0], 0, -16, 7, 'center');
    ctx.font = 'italic 500 40px ' + SERIF;
    ctx.textAlign = 'center';
    ctx.fillText(lines[1], 0, 24);
    ctx.restore();
  }

  function draw(canvas, d, assets) {
    var ctx = canvas.getContext('2d');
    var W = 1080, H = 1920;
    canvas.width = W; canvas.height = H;
    ctx.textBaseline = 'alphabetic';

    /* Ground */
    ctx.fillStyle = C.green; ctx.fillRect(0, 0, W, H);

    /* Eyebrow on the green */
    ctx.fillStyle = 'rgba(243,235,220,0.72)';
    ctx.font = '500 24px ' + SANS;
    spaced(ctx, 'THE QUIZ HAS SPOKEN', W / 2, 318, 8, 'center');

    /* The card: a club document, slightly askew */
    var cx = W / 2, cy = 930, cw = 880, ch = 1080;
    ctx.save();
    ctx.translate(cx, cy); ctx.rotate(-0.035);
    ctx.shadowColor = 'rgba(0,0,0,0.32)'; ctx.shadowBlur = 40; ctx.shadowOffsetY = 18;
    ctx.fillStyle = C.cream; ctx.fillRect(-cw / 2, -ch / 2, cw, ch);
    ctx.shadowColor = 'transparent';
    ctx.strokeStyle = C.green; ctx.lineWidth = 2;
    ctx.strokeRect(-cw / 2 + 26, -ch / 2 + 26, cw - 52, ch - 52);
    ctx.lineWidth = 1;
    ctx.strokeRect(-cw / 2 + 34, -ch / 2 + 34, cw - 68, ch - 68);

    var L = -cw / 2 + 74, R = cw / 2 - 74, top = -ch / 2;

    /* Wordmark from the real logo file */
    if (assets.wordmark) {
      var ww = 250, wh = ww * assets.wordmark.height / assets.wordmark.width;
      ctx.drawImage(assets.wordmark, -ww / 2, top + 66, ww, wh);
    }

    /* Form header row */
    var ry = top + 230;
    ctx.fillStyle = C.green; ctx.font = '500 19px ' + SANS;
    spaced(ctx, 'OFFICIAL RESULT', L, ry, 5, 'left');
    spaced(ctx, 'SEALED, NOT SCORED', R, ry, 5, 'right');
    rule(ctx, L, ry + 18, R, 1, 'rgba(46,75,63,0.55)');

    /* Illustration */
    var iy = top + 392, ir = 122;
    ctx.save();
    ctx.beginPath(); ctx.arc(0, iy, ir, 0, Math.PI * 2); ctx.closePath();
    ctx.fillStyle = C.white; ctx.fill();
    if (assets.illus) {
      ctx.clip();
      var s = (ir * 2) / Math.min(assets.illus.width, assets.illus.height);
      var iw = assets.illus.width * s, ih = assets.illus.height * s;
      ctx.drawImage(assets.illus, -iw / 2, iy - ih / 2, iw, ih);
    }
    ctx.restore();
    ctx.strokeStyle = C.green; ctx.lineWidth = 1.5;
    ctx.beginPath(); ctx.arc(0, iy, ir + 10, 0, Math.PI * 2); ctx.stroke();

    /* Name: italic "The", roman rest */
    var rest = d.name.replace(/^The\s+/, '');
    var ny = top + 680;
    ctx.fillStyle = C.green; ctx.textAlign = 'center';
    ctx.font = 'italic 400 48px ' + SERIF;
    ctx.fillText('The', 0, ny - 98);
    var ns = fitSize(ctx, rest, '500 %spx ' + SERIF, 112, R - L - 20, 70);
    ctx.font = '500 ' + ns + 'px ' + SERIF;
    ctx.fillText(rest, 0, ny);
    var nw = ctx.measureText(rest).width;
    scribble(ctx, -nw / 2 - 6, ny + 18, nw + 12, d.seed || 7, C.matcha, 13);

    /* One-liner */
    ctx.font = 'italic 400 46px ' + SERIF;
    ctx.fillText(String.fromCharCode(8220) + d.line + String.fromCharCode(8221), 0, ny + 100);

    /* Filled-in form fields */
    var fy = ny + 178;
    var labels = ['HANDICAP', 'DRESS CODE', 'LAST SEEN'];
    labels.forEach(function (lab, i) {
      var y = fy + i * 74;
      ctx.textAlign = 'left';
      ctx.fillStyle = C.soft; ctx.font = '500 17px ' + SANS;
      spaced(ctx, lab, L, y, 4, 'left');
      ctx.fillStyle = C.green; ctx.font = 'italic 500 38px ' + SERIF;
      ctx.textAlign = 'right';
      ctx.fillText(d.fields[i] || '', R, y + 2);
      rule(ctx, L, y + 16, R, 1, 'rgba(46,75,63,0.35)');
    });
    ctx.restore();

    /* Scorecard sticker slapped on the corner */
    sticker(ctx, 842, 468, 0.13, ['NOT KEEPING', 'Score.']);

    /* Below the card */
    ctx.textAlign = 'center'; ctx.fillStyle = C.cream;
    ctx.font = 'italic 400 60px ' + SERIF;
    ctx.fillText('Which one are you?', W / 2, 1566);
    ctx.fillStyle = 'rgba(243,235,220,0.8)'; ctx.font = '500 22px ' + SANS;
    spaced(ctx, 'NINETEENTHSOCIETY.COM', W / 2, 1618, 7, 'center');
    if (assets.mark) {
      var mw = 92, mh = mw * assets.mark.height / assets.mark.width;
      ctx.globalAlpha = 0.9;
      ctx.drawImage(assets.mark, W / 2 - mw / 2, 178, mw, mh);
      ctx.globalAlpha = 1;
    }
    return canvas;
  }

  function build(canvas, d, urls) {
    var fontLoads = [
      '500 112px "NS Card Serif"', 'italic 400 48px "NS Card Serif"', 'italic 500 38px "NS Card Serif"',
      '500 24px "NS Card Sans"'
    ].map(function (f) { return document.fonts && document.fonts.load ? document.fonts.load(f).catch(function () {}) : null; });
    return Promise.all(fontLoads).then(function () {
      return Promise.all([loadImg(urls.wordmark), loadImg(urls.mark), loadImg(urls.illus)]);
    }).then(function (imgs) {
      try {
        draw(canvas, d, { wordmark: imgs[0], mark: imgs[1], illus: imgs[2] });
        canvas.toDataURL('image/png');
      } catch (e) {
        draw(canvas, d, { wordmark: imgs[0], mark: imgs[1], illus: null });
      }
      return canvas;
    });
  }

  root.NSPersonaCard = { draw: draw, build: build };
})(window);
